import React from 'react';

import CustomAttachmentDisplayValue from 'containers/EntitiesFormSubmission/components/CustomAttachmentField/CustomAttachmentDisplayValue';

import { isFileImage } from 'ui/files';

import AuditAttachmentThumb from './AuditAttachmentThumb';
import { AuditAttachment } from './types';
import { AttachmentAnswer, AttachmentThumbs } from './styles';

type AuditAttachmentAnswerProps = {
  questionKey: string;
  files: AuditAttachment[];
};

// Photos show as thumbnails; everything else keeps the shared file row. Opt-in here because
// CustomFieldDisplayValue also serves Events, which keeps its file rows.
const AuditAttachmentAnswer: React.FunctionComponent<AuditAttachmentAnswerProps> = ({ questionKey, files }) => {
  const images = files.filter(({ filename }) => isFileImage(filename));
  const others = files.filter(({ filename }) => !isFileImage(filename));

  return (
    <AttachmentAnswer>
      {images.length > 0 && (
        <AttachmentThumbs data-testid={`audit-question-attachments-${questionKey}`}>
          {images.map((file) => (
            <AuditAttachmentThumb key={file.filename} questionKey={questionKey} file={file} />
          ))}
        </AttachmentThumbs>
      )}

      {others.length > 0 && <CustomAttachmentDisplayValue value={others} submissionTab />}
    </AttachmentAnswer>
  );
};

export default AuditAttachmentAnswer;
